export default "__VITE_ASSET__CYPPr6gy__"